import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

// action
export const fetchDeviceList = createAsyncThunk("fetchDeviceList", async (params) => {
	try {
		const queryParams = {
			...params,
			page: Number(params.page) || 1,
			limit: Number(params.limit) || 10,
			companyId: params.company ? Number(params.company) : undefined,
			locationId: params.location ? Number(params.location) : undefined,
			deviceType: params.deviceType ? String(params.deviceType) : undefined,
			isActive: params.isActive !== undefined ? Boolean(params.isActive) : undefined,
			search: params.search ? String(params.search) : undefined,
		};

		const response = await axiosHttp.get("attendance/devices/list", { params: queryParams });
		return response.data;
	} catch (error) {
		throw error.response.data.message;
	}
});

// slice
const deviceListSlice = createSlice({
	name: "deviceList",
	initialState: {
		data: null,
		isLoading: false,
		error: null,
	},
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchDeviceList.pending, (state) => {
				state.isLoading = true;
				state.data = null;
				state.error = null;
			})
			.addCase(fetchDeviceList.fulfilled, (state, action) => {
				state.isLoading = false;
				state.data = action.payload;
			})
			.addCase(fetchDeviceList.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload;
			});
	},
});

export const { resetDeviceList } = deviceListSlice.actions;

export default deviceListSlice.reducer;
